namespace Nobox {
    export interface ChatmessagesRow {
        Id?: number;
        IdAlias?: string;
        GrpMember?: string;
        RoomId?: number;
        Ack?: number;
        From?: number;
        ReplyFrom?: number;
        To?: number;
        AgentId?: number;
        IsNobox?: number;
        Type?: string;
        Msg?: string;
        Files?: string;
        File?: string;
        ReplyType?: string;
        ReplyMsg?: string;
        ReplyFiles?: string;
        ReplyGrpMember?: string;
        ReplyId?: number;
        InteractiveMsg?: string;
        InteractiveType?: number;
        Note?: string;
        In?: string;
        InBy?: number;
        Up?: string;
        UpBy?: number;
    }

    export namespace ChatmessagesRow {
        export const idProperty = 'Id';
        export const nameProperty = 'AgentId';
        export const localTextPrefix = 'Chat.Chatmessages';
        export const lookupKey = 'Chat.Chatmessages';

        export function getLookup(): Q.Lookup<ChatmessagesRow> {
            return Q.getLookup<ChatmessagesRow>('Chat.Chatmessages');
        }
        export const deletePermission = 'ChatMessage:Delete';
        export const insertPermission = 'ChatMessage:Modify';
        export const readPermission = 'ChatMessage:View';
        export const updatePermission = 'ChatMessage:Modify';

        export declare const enum Fields {
            Id = "Id",
            IdAlias = "IdAlias",
            GrpMember = "GrpMember",
            RoomId = "RoomId",
            Ack = "Ack",
            From = "From",
            ReplyFrom = "ReplyFrom",
            To = "To",
            AgentId = "AgentId",
            IsNobox = "IsNobox",
            Type = "Type",
            Msg = "Msg",
            Files = "Files",
            File = "File",
            ReplyType = "ReplyType",
            ReplyMsg = "ReplyMsg",
            ReplyFiles = "ReplyFiles",
            ReplyGrpMember = "ReplyGrpMember",
            ReplyId = "ReplyId",
            InteractiveMsg = "InteractiveMsg",
            InteractiveType = "InteractiveType",
            Note = "Note",
            In = "In",
            InBy = "InBy",
            Up = "Up",
            UpBy = "UpBy"
        }
    }
}
